import { Component } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  BooleanCustomFieldConfig,
  SharedModule,
  FormInputComponent,
} from "@bb-vendure/admin-ui/core";

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./customs-clearance-active-section.component.html",
})
export class CustomsClearanceActiveSection
  implements FormInputComponent<BooleanCustomFieldConfig>
{
  isListInput?: boolean | undefined = false;
  readonly: boolean;
  formControl: FormControl<any>;
  config: BooleanCustomFieldConfig;
}
